import clsx from 'clsx';

export interface DocumentSettingsSectionProps {
    renderSettings: () => React.ReactNode;
    className?: string;
}

export const DocumentSettingsSection: React.FC<DocumentSettingsSectionProps> = ({
    renderSettings,
    className
}) => {
    return (
        <div className={clsx(
            'flex flex-col gap-6',
            className
        )}>
            <div className='flex flex-col gap-4 px-5'>
                <h1 className='text-2xl md:text-3xl font-medium text-[#0b111e]'>Nastavení dokumentu</h1>
                {renderSettings()}
            </div>
        </div>
    );
};
